import {
  SearchBox,
  PrimaryButton,
  Separator,
  Stack,
  Dropdown,
  TextField,
  Pivot,
  PivotItem,
  Label,
  Toggle
} from "@fluentui/react";
import React, { useEffect, useState } from 'react';
import useAxios from "axios-hooks";
import { Spinner } from "@fluentui/react";
import { useClickOutside } from 'react-click-outside-hook'
import ErrorComponent from "../../../../Util/ErrorComponent";
import { axiosInstance } from '../../../../../api/config';
import env from "../../../../../env";
const { REACT_APP_API_BASE_URI } = env;
import Select from 'react-select';
import { FixedSizeList as List } from 'react-window';
import Toast from "../../../../Forms/Toast";
import CobrandDropDown from "../../../Checklist/Checklists/Forms/CobrandDropDown";

const CustomMenuList = ({ children, ...props }) => {
  const height = 35;
  const itemCount = children.length;
  const totalHeight = Math.min(300, itemCount * height);

  return (
    <List height={totalHeight} itemCount={itemCount} itemSize={height} width="100%">
      {({ index, style }) => (
        <div
          style={{
            ...style,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            padding: '0 8px',
            boxSizing: 'border-box',
          }}
          title={children[index]?.props?.children}
        >
          {children[index]}
        </div>
      )}
    </List>
  );
};


export function InlineDisplay({ label, value }) {
  const textStyle = {
    color: "#646464",
    fontSize: "15px",
    marginLeft: "0.5em",
    marginTop: "0.3em",
    margingBottom: "0.2em"
  };

  const valueStyle = {
    color: "#323130",
    fontSize: "15px",
  };

  return (
    <>
      <div style={textStyle}>
        {label}:  <span style={valueStyle}>{value}</span>
      </div>
    </>
  );
}



export function ReAssignUser({ user, setCurrentUserDetails, updateGrid }) {
  const [username, setNewUsername] = React.useState(user.userName);
  const [coBrandOptions, setCoBrandOptions] = React.useState([{}]);
  const [schoolOptions, setSchoolOptions] = React.useState([{}]);
  const [showToast, setShowToast] = React.useState(false);
  const [clientId, setClientId] = React.useState();
  const [coBrandId, setCoBrandId] = React.useState();
  const [schoolId, setSchoolId] = React.useState();
  const [userType, setUserTypeId] = React.useState();
  const [ref, hasClickedOutside] = useClickOutside();

  const [{ data: clientOptions }] = useAxios(
    {
      url: `2020-05-05/user/options/0?userOptionType=Client`,
      method: "get",
      baseURL: REACT_APP_API_BASE_URI,
    },
    { axios: axiosInstance }
  );

  const clients = clientOptions?.map(u => ({ value: u.id, label: u.name }));

  const [{ data: userTypes }] = useAxios(
    {
      url: `2020-05-05/user/options/0?userOptionType=UserType`,
      method: "get",
      baseURL: REACT_APP_API_BASE_URI,
    },
    { axios: axiosInstance }
  );
  const [, executeGetCoBrands] = useAxios(
    {
      url: `2020-05-05/user/options/${clientId}?userOptionType=CoBrand`,
      method: "get",
      baseURL: REACT_APP_API_BASE_URI,
    },
    { axios: axiosInstance, manual: true }
  );



  const [, executeGetSchools] = useAxios(
    {
      url: `2020-05-05/user/options/${coBrandId}?userOptionType=School`,
      method: "get",
      baseURL: REACT_APP_API_BASE_URI,
    },
    { axios: axiosInstance, manual: true }
  );

  const [
    { loading: loadingUserData, error },
    executeReAssignUser,
  ] = useAxios(
    {
      method: "put",
      url: `2020-05-05/user/reassign`,
      data: { username, coBrandId, schoolId, userType },
      baseURL: REACT_APP_API_BASE_URI,
    },
    { axios: axiosInstance, manual: true }
  );

  const dropdownStyles = {
    dropdown: { width: 300 },
  };


  React.useEffect(() => {
    setCoBrandOptions([{}]);
    setSchoolOptions([{}]);
    if (clientId) {
      executeGetCoBrands().then((response) => {
        if (response && response.data) {
          let formattedCoBrandOptions = response.data.map((coBrandOption) => {
            return { key: coBrandOption.id, text: coBrandOption.name };
          });

          setCoBrandOptions(formattedCoBrandOptions);
        }
      });
    }
  }, [clientId]);

  React.useEffect(() => {
    setSchoolOptions([{}]);
    if (coBrandId) {
      executeGetSchools().then((response) => {
        if (response && response.data) {
          let formattedSchoolOptions = response.data.map((school) => {
            return { key: school.id, text: school.name };
          });

          setSchoolOptions(formattedSchoolOptions);
        }
      });
    }
  }, [coBrandId]);
  const selectedClient = clients?.find(option => option.value === clientId);
  return (
    <>
      {user &&
        <div style={{ height: 700 }}>

          <label className="default-label">Client</label>
          <Select
            options={clients}
            placeholder="Select Client"
            name="cobrandId"
            value={selectedClient || null}
            onChange={(option) => {
              setClientId(option.value)
            }}
            isSearchable
            styles={{
              menuList: base => ({ ...base, maxHeight: '300px', overflowY: 'auto' }),
              container: base => ({ ...base, width: 300 }),
              control: base => ({ ...base, border: '1px solid #aaaaaa' }),
            }}
          />


          <Dropdown
            placeHolder=""
            options={coBrandOptions}
            name="CoBrandOptions"
            label="CoBrand"
            styles={dropdownStyles}
            onChange={(event, item) => setCoBrandId(item.key)}
          />

          <Dropdown
            placeHolder=""
            options={schoolOptions}
            name="SchoolOptions"
            label="School (Optional)"
            styles={dropdownStyles}
            onChange={(event, item) => setSchoolId(item.key)}
          />

          <Dropdown
            placeHolder="Select a User Type"
            options={
              userTypes &&
              userTypes.map((userType) => ({
                key: userType.id,
                text: userType.name,
              }))
            }
            name="UserTypeOptions"
            label="User Type (Optional)"
            styles={dropdownStyles}
            onChange={(event, item) => setUserTypeId(item.key)}
          />

          <br />
          <div ref={ref}>
            <PrimaryButton
              id="ReassignUser"
              text="Reassign User"
              loading={loadingUserData}
              disabled={!coBrandId || !clientId}
              onClick={async () => {
                try {
                  if (hasClickedOutside) {
                    return;
                  }
                  else {
                    await executeReAssignUser().then((newUserDetails) => {
                      setCurrentUserDetails(newUserDetails.data);
                      updateGrid();
                      setShowToast(true)
                    });
                  }

                } catch (e) {
                  throw e;
                }

              }}
            ></PrimaryButton>
          </div>
        </div>
      }
      <Toast show={showToast} message="Saved" onClose={() => setShowToast(false)} />
    </>
  );
}

export function UpdateUser({ user, setCurrentUserDetails, updateGrid }) {
  const [username, setNewUsername] = React.useState(user.userName);
  const [memberStatus, setMemberStatus] = React.useState(user.memberStatus);
  const [excludeFromReports, setExcludeFromReports] = React.useState(user.excludeFromReports);
  const [showToast, setShowToast] = React.useState(false);
  const memberStatusOptions = [
    { key: "A", text: "Active (A)" },
    { key: "D", text: "Disabled (D)" },
  ];
  let memberId = user.userId;

  const [
    { data: userDetails, loading: updatingUser, error },
    executeUpdateUser,
  ] = useAxios(
    {
      method: "put",
      url: `2020-05-05/user/update`,
      data: { username, memberStatus, memberId, excludeFromReports },
      baseURL: REACT_APP_API_BASE_URI,
    },
    { axios: axiosInstance, manual: true }
  );

  const dropdownStyles = {
    dropdown: { width: 300 },
  };

  const columnProps = {
    tokens: { childrenGap: 15 },
    styles: { root: { width: 300 } },
  };

  return (
    <>
      {user &&
        <>
          <Stack {...columnProps}>
            <TextField
              label="Email address (username)"
              onChange={(event, newValue) => {
                setNewUsername(newValue);
              }}
            />
            <Dropdown
              placeHolder="Select Member Status"
              options={memberStatusOptions}
              name="MemberStatusOptions"
              label="Member Status"
              styles={dropdownStyles}
              onChange={(event, item) => setMemberStatus(item.key.charAt(0))}
            />
            <Toggle
              label="Exclude From Reports"
              checked={excludeFromReports}
              onText="Yes"
              offText="No"
              onChange={(e, checked) => setExcludeFromReports(checked)}
              styles={{ root: { marginTop: 10 } }}
            />
          </Stack>
          <br />
          <PrimaryButton
            text="Update User"
            loading={updatingUser}
            onClick={async () => {
              try {
                await executeUpdateUser().then((newUserDetails) => {
                  setCurrentUserDetails(newUserDetails.data);
                  updateGrid();
                  setShowToast(true);
                });
              } catch (e) {
                throw e;
              }
            }}
          ></PrimaryButton>
          <Toast show={showToast} message="Saved" onClose={() => setShowToast(false)} />
        </>
      }
    </>
  );
}

const ManageUsers = ({ memberId, updateGrid }) => {
  const [curentUserDetails, setCurrentUserDetails] = React.useState(null);
  const [{ data, loading: getMemberDetailsLoading }, executeGetMemberDetails] =
    useAxios(
      {
        url: `2020-05-05/internal/user/details/${memberId}`,
        method: "get",
        baseURL: REACT_APP_API_BASE_URI,
      },
      { axios: axiosInstance, manual: true }
    );

  useEffect(() => {
    getDate()
  }, []);

  const getDate = async () => {
    await executeGetMemberDetails().then((userDetailsResponse) => {
      if (userDetailsResponse.data.responseCode !== 204) {
        setCurrentUserDetails(userDetailsResponse.data);
      }
    });
  }

  const labelStyles = {
    root: { marginTop: 10 },
  };

  return (
    <>

      {getMemberDetailsLoading
        ? <Spinner className="absolute-center" label="Loading User..." />
        : <>
          {curentUserDetails &&
            <Pivot aria-label="">
              <PivotItem headerText="ReAssign User">
                <Label styles={labelStyles}>
                  <ReAssignUser
                    user={curentUserDetails}
                    updateGrid={updateGrid}
                    setCurrentUserDetails={setCurrentUserDetails}
                  ></ReAssignUser>
                </Label>
              </PivotItem>
              <PivotItem headerText="Update User">
                <Label styles={labelStyles}>
                  <UpdateUser
                    updateGrid={updateGrid}
                    user={curentUserDetails}
                    setCurrentUserDetails={setCurrentUserDetails}
                  ></UpdateUser>
                </Label>
              </PivotItem>
            </Pivot>
          }
        </>
      }


    </>
  );
};

export default ManageUsers;
